import React, { useEffect, useState } from 'react';
import { Lock, Tag, Copy, Check, ExternalLink } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/membership`;

const CodeChip = ({ code }) => {
  const [ok, setOk] = useState(false);
  return (
    <button onClick={() => { navigator.clipboard.writeText(code).catch(() => {}); setOk(true); setTimeout(() => setOk(false), 1500); }}
      className="inline-flex items-center gap-1 rounded-lg border-2 border-dashed border-party-green bg-green-50 px-3 py-1 font-mono text-sm font-bold text-party-green" data-testid={`perk-code-${code}`}>
      {code} {ok ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
    </button>
  );
};

export const MemberPerks = ({ mobile }) => {
  const { t } = useLanguage();
  const [data, setData] = useState(null);
  useEffect(() => {
    fetch(`${API}/perks?mobile=${encodeURIComponent(mobile)}`).then(r => (r.ok ? r.json() : null)).then(setData).catch(() => {});
  }, [mobile]);
  if (!data || data.partners.length === 0) return null;

  return (
    <div className="rounded-2xl border bg-white p-4 sm:p-5 shadow-sm" data-testid="member-perks">
      <div className="mb-3 flex items-center gap-2">
        <Tag className="h-5 w-5 text-party-red" />
        <h3 className="font-bold text-gray-900">{t({ en: 'Partner Discounts', bn: 'পার্টনার ছাড়' })}</h3>
        {!data.unlocked && <span className="ml-auto inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-bold text-amber-700" data-testid="perks-locked-badge"><Lock className="h-3 w-3" /> {t({ en: 'Locked', bn: 'লক' })}</span>}
      </div>
      {!data.unlocked && (
        <p className="mb-3 rounded-lg bg-amber-50 p-3 text-xs text-amber-800" data-testid="perks-locked-msg">
          {t({ en: 'Pay the 100 BDT membership fee (bKash/Nagad 01732341999). Once your membership is verified, your discount codes appear here.', bn: '১০০ টাকা সদস্য ফি পরিশোধ করুন (bKash/নগদ 01732341999)। সদস্যপদ যাচাই হলে আপনার ডিসকাউন্ট কোড এখানে দেখা যাবে।' })}
        </p>
      )}
      <ul className="space-y-2">
        {data.partners.map((p) => (
          <li key={p._id} className="flex flex-wrap items-center gap-3 rounded-xl border p-3" data-testid={`member-perk-${p._id}`}>
            {p.logo_url ? <img src={p.logo_url} alt={p.name} className="h-10 w-10 rounded-lg object-contain" /> : <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-party-red/10 font-bold text-party-red">{p.name[0]}</div>}
            <div className="min-w-0 flex-1">
              <p className="text-sm font-bold text-gray-900">{p.name} {p.website && <a href={p.website} target="_blank" rel="noopener noreferrer" className="inline-block align-middle text-gray-400"><ExternalLink className="h-3 w-3" /></a>}</p>
              <p className="text-xs text-gray-500">{t(p.discount)}</p>
            </div>
            {data.unlocked ? <CodeChip code={p.code} /> : <span className="rounded-lg bg-gray-100 px-3 py-1 font-mono text-sm text-gray-400 blur-[3px] select-none">NDP-XXXX</span>}
          </li>
        ))}
      </ul>
    </div>
  );
};
